const APP_ENV_FIELD = "REACT_APP_ENV";
const API_URL_FIELD = "REACT_APP_API_URL";
const FIREBASE_DYNAMIC_LINK_URL = "REACT_APP_FIREBASE_DYNAMIC_LINK_URL";
const REACT_APP_API_MS_URL_FIELD = "REACT_APP_API_MS_URL";

export const environmentName = process.env[APP_ENV_FIELD];

export const apiUrl = process.env[API_URL_FIELD];
export const apiMsUrl = process.env[REACT_APP_API_MS_URL_FIELD];

export const firebaseDynamicLinkUrl = process.env[FIREBASE_DYNAMIC_LINK_URL];
